import { Component } from '@angular/core';
import { TopNavbar } from './top-navbar/top-navbar';
import { HeroSection } from './hero-section/hero-section';
import { AboutUs } from './about-us/about-us';
import { SystemFeatures } from './system-features/system-features';
import { MelFramework } from './mel-framework/mel-framework';
import { FlagshipProjects } from './flagship-projects/flagship-projects';
import { FaqsComponent } from './faqs-component/faqs-component';
import { Footer } from './footer/footer';
import { EnrolledInstitutions } from './enrolled-institutions/enrolled-institutions';
import { AccessibilityWidget } from '../../shared/components/accessibility-widget/accessibility-widget';

@Component({
  selector: 'app-landing-page',
  imports: [
    TopNavbar,
    HeroSection,
    AboutUs,
    SystemFeatures,
    MelFramework,
    FlagshipProjects,
    FaqsComponent,
    Footer,
    EnrolledInstitutions,
    AccessibilityWidget,
  ],
  templateUrl: './landing-page.html',
  styleUrl: './landing-page.scss',
})
export class LandingPage {}
